import { render } from "./DashboardStatsRow.vue?vue&type=template&id=1c573477"
import script from "./DashboardStatsRow.vue?vue&type=script&lang=js"
export * from "./DashboardStatsRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__